module.exports = __webpack_public_path__ + "static/media/upi.a0ae64bb.png";